import MedicalConditionsFragment from "./MedicalConditionsFragment";
import ShareVATInfoFragment from "./ShareVATInfoFragment";
import VATInfo from "./VATInfo";

function VatForm() {

  return (
    <div className="toggle-container">
      <div className='checkbox-and-input'>
        <div style={{ margin: '20px 0' }}>
          <VATInfo />
        </div>
        <div className='form-line'>
          <MedicalConditionsFragment />
        </div>

        <div className='form-line'>
          <ShareVATInfoFragment />
        </div>

      </div>
    </div>
  );
}

export default VatForm;